export const signUpResponse = {
  ok: true,
  data: {
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3VzZXJkYXRhIjoie1wiaWRcIjpcIjA4ZDczZDUwLTZmZjMtNTk0ZS0xMDE0LTA1OWI5ZjZkOTMxN1wifSIsImV4cCI6MTU2OTUzNjc5OCwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NTAwMSIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6MzAwMCJ9.d01uBxxk0lGMlOmRsTi2JpFx5zrloyJjTpQ5MWvXkU8',
  },
};
